import { Button, Select } from '@nazka/nazka.mapframe.components'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { useTranslation } from '@utils/i18n/i18n.consumers';

import './adaptation-list-component.styl';

const TABS = [
  { id: 'all', label: 'All' },
  { id: 'plans', label: 'Plans' },
  { id: 'stories', label: 'Stories' },
]

function AdaptationListComponent({ selectedCategory }) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { map } = useOutletContext();
  const addButtonLabel = selectedCategory === 'plans'
    ? t('Add plan')
    : t('Add story');
  const adaptationTypeOptions = [
    { value: 'plan', label: t('Plan') },
    { value: 'story', label: t('Story') },
  ];

  // Hacky way to dynamically set the width of the dropdown based on the longest option label, while also ensuring it doesn't exceed the viewport width minus some padding.
  const dropdownWidth = `min(calc(${Math.max(...adaptationTypeOptions.map(option => option.label.length))}ch + 28px), calc(100vw - 28px))`;
  
  return (
    <div className="adaptation-list-component">
      <h4>
        {selectedCategory === 'plans' && (
          <>
            <span>{t('Adaptation')}</span>
            <span className="adaptation-list-component__plans-title">{t('plans')}</span>
          </>
        )}
        {selectedCategory === 'stories' && (
          <>
            <span>{t('Adaptation')}</span>
            <span className="adaptation-list-component__stories-title">{t('stories')}</span>
          </>
        )}
        {selectedCategory === 'all' && (
          <>
            <span>{t('Adaptation')}</span>
            <span className="adaptation-list-component__all-plan-title">{t('plans')}</span>
            <span>{t('and')}</span>
            <span className="adaptation-list-component__all-story-title">{t('stories')}</span>
          </>
        )}
      </h4>
      <div className="adaptation-list-component__header">
        <div className="adaptation-list-component__filters my-second-adaptation-step">
          {TABS.map(tab => (
            <button
              key={tab.id}
              type="button"
              onClick={() => {
                if (tab.id === 'all') {
                  navigate('/adaptation')
                } else {
                  navigate(`/adaptation/${tab.id}`)
                }
              }}
              className={`adaptation-list-component__btn ${selectedCategory === tab.id ? 'adaptation-list-component__btn--active' : ''}`}
            >
              <span>{t(tab.label)}</span>
            </button>
          ))}
        </div>
        {selectedCategory === 'all' ? (
          <div className="adaptation-list-component__add my-fourth-adaptation-step">
            <Select
              disabled={!map}
              options={adaptationTypeOptions}
              placeholder={`+ ${t('Add')}`}
              menuStyle={{
                marginTop: '6px',
                borderRadius: '8px',
                width: dropdownWidth,
              }}
              css={{
                borderRadius: '8px',
                backgroundColor: !map ? '#ddd' : '#72A276',
                color: 'white',
                border: 'none',
                height: '40px',
                '&:hover': {
                  backgroundColor: '#5c8e60',
                },
              }}
              hideToggleIcon
              onInputChange={(value) => {
                if (value.value === 'plan') {
                  navigate('/adaptation/plans/create')
                } else if (value.value === 'story') {
                  navigate('/adaptation/stories/create')
                }
              }}
            />
          </div>
        ) : (
          <div className="adaptation-list-component__add my-fourth-adaptation-step">
            <Button
              disabled={!map}
              onClick={() => navigate(`/adaptation/${selectedCategory === 'plans' ? 'plans' : 'stories'}/create`)}
              css={{
                borderRadius: '8px',
                color: 'white',
                height: '40px',
                '&:hover': {
                  color: 'white',
                },
              }}
              className="adaptation-list-component__add-btn"
            >
              {addButtonLabel}
            </Button>
          </div>
        ) }
      </div>
    </div>
  )
}

export default AdaptationListComponent
